if (!customElements.get('c-ingredients-carousel')) {
  class CIngredientsCarousel extends HTMLElement {
    connectedCallback() {
      const slider = this.querySelector('.c-ingredients-carousel__slider');
      if (!slider || !slider.querySelector('.swiper-slide') || !window.Swiper) return;

      this.swiper = new window.Swiper(slider, {
        slidesPerView: parseFloat(this.dataset.slidesMobile) || 1.1,
        spaceBetween: 24,
        grabCursor: true,
        watchOverflow: true,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        breakpoints: {
          768: {
            slidesPerView: parseFloat(this.dataset.slidesTablet) || 2.5,
          },
          1200: {
            slidesPerView: parseFloat(this.dataset.slidesDesktop) || 4,
          },
        },
      });

      this.resizeTimer = null;
      this.handleResize = () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => this.equalizeDescriptionHeights(), 150);
      };
      window.addEventListener('resize', this.handleResize);

      requestAnimationFrame(() => this.equalizeDescriptionHeights());
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.equalizeDescriptionHeights());
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      clearTimeout(this.resizeTimer);
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    equalizeDescriptionHeights() {
      const descriptions = Array.from(this.querySelectorAll('.c-ingredients-carousel__description'));
      if (descriptions.length === 0) return;

      this.style.removeProperty('--c-ingredients-description-min-height');
      const maxHeight = Math.max(...descriptions.map((description) => description.offsetHeight));
      this.style.setProperty('--c-ingredients-description-min-height', `${maxHeight}px`);
    }
  }

  customElements.define('c-ingredients-carousel', CIngredientsCarousel);
}